module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h1', {
    staticClass: "tocchaptitle"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U001.jpg"
    }
  }), _vm._v(" CONTENTS "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/U002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/04_chapter01#c1"
    }
  }, [_c('b', [_vm._v("1. SOMETHING WICKED:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/04_chapter01#c1"
    }
  }, [_vm._v("Mysterious Objects and Haunted Homes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/05_chapter02#c2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2. THE ANNUAL CHICKEN SHOW:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/05_chapter02#c2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enchanted Animals, Psychic Pets, Botanical Oddities, "), _c('br'), _vm._v("and Other Strange Truths about Mother Nature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/06_chapter03#c3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3. HISTORY'S MYSTERIES:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/06_chapter03#c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bizarre but True Facts about Historical Figures, "), _c('br'), _vm._v("and Oddities from Today and Yesterday")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/07_chapter04#c4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4. TENDER MURDERERS AND MALEVOLENT MALES:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/07_chapter04#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Killingly Good Tales of Terror")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/08_chapter05#c5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5. COINCIDENCE OR SYNCHRONICITY?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/08_chapter05#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Odd Things Happening to Ordinary Folks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/09_chapter06#c6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6. MORBID WRITERS AND TORTURED ARTISTS:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/09_chapter06#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Edgar Allan Poe to Vincent Van Gogh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter07#c7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7. DIA DE LOS MUERTOS:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter07#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corpses on Campus, Voices from Beyond the Grave, "), _c('br'), _vm._v("Strange Cemetery Facts, Spooky Specters, and Other"), _c('br'), _vm._v(" Ghostly, Ghastly, and Gothic Goings On")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter08#c8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8. SYMPATHY FOR THE DEVIL:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter08#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strange Rock-and-Roll Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter09#c9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9. STILL ON THE BOOKS (AND IN THE ETHER):")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter09#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Weirdest Laws in the World, Hoaxes, and Conspiracy Theories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10. PASSING STRANGE:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aberrations, Fascinating Phobias, and Odd Ancient Beliefs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11. THE VAPORS:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Medical Maladies and Curious Cures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12. SUPERSTITIONS AND CURSES:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Hex, Lambast, and Bewitch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13. THE DARK SIDE OF THE MOON:")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UFO Stories and Bizarre and True Lunar Facts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_biblogrpahy#biblo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ceaac0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_contents.vue
// module id = 66
// module chunks = 0